module.exports = __webpack_public_path__ + "img/stock3.1cc0f6d1.png";